export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELOTBtcy1SS1NKLUhhA4GoAIVjAACFYgABhWBhBoFBAb1PDQG9UQkCvVMCBL1WBBG9WwYAvW1hAoFDAMBMAADAUkEVgazAToFyhUEBAAEAAQABABkAHwABAAEABgBTAAEAAQABAAEAGQAgAAEAAQAGAGEBg5UBvgJRIISfujkFHg4JET4RHjE+cwUiDgkRRhEeMU45DxwvQiUXJDdCcQyHXwG+BADBCQC+BwDBEwC+CQDBEgG+CwDBGAG+DgDBHAG+EQDBHWEBh4ABvhQ=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/90ms-RKSJ-V.bcmap
// module id = 577
// module chunks = 502